import { useQuery } from "@tanstack/react-query";
import { preMaintenanceApi } from "./axios";
import {
  DataI,
  ServiceResponseI,
  PreMaintenanceI,
  PropsPreMaintenanceI,
} from "../../interfaces";
import { ValidateCurrentToken, LogoutSystem } from "../../helpers";
import { AxiosError } from "axios";

const getPreMaintenances = async ({
  pagination,
  sorting,
  globalFilter,
  startDate,
  endDate,
}: PropsPreMaintenanceI): Promise<ServiceResponseI<DataI<PreMaintenanceI>>> => {
  try {
    const validateToken = ValidateCurrentToken();

    if (!validateToken) throw new Error("TOKEN INVALIDO");

    const params = new URLSearchParams();

    params.append("page", (pagination!.pageIndex + 1).toString());
    params.append("limit", pagination!.pageSize.toString());
    params.append("search", globalFilter ?? "");
    params.append("sorting", JSON.stringify(sorting ?? []));
    startDate && params.append("startDate", startDate);
    endDate && params.append("endDate", endDate);

    //headers: { 'Authorization': validateToken
    const { data } = await preMaintenanceApi.get<ServiceResponseI<DataI<PreMaintenanceI>>>("", {
      params,
      headers: { Authorization: validateToken },
    });
    return data;
  } catch (err) {
    const obj = (err as AxiosError).response;

    if (obj?.status === 401) {
      LogoutSystem();
    }

    throw new Error((err as Error).message);
  }
};


export const usePreMaintenances = ({
  sorting,
  pagination,
  globalFilter,
  startDate,
  endDate,
}: PropsPreMaintenanceI) => {
  const otsQuery = useQuery(
    [
      "pre-maintenances",
      {
        pagination,
        sorting,
        globalFilter,
        startDate,
        endDate,
      },
    ],
    () =>
      getPreMaintenances({
        pagination,
        sorting,
        globalFilter,
        startDate,
        endDate,
      }),
    {
      refetchOnWindowFocus: false,
      keepPreviousData: true,
      cacheTime: 0, 
      staleTime: 0
    }
  );

  return {
    otsQuery,
  };
};
